import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ImageState {
  selectedImageKey: string
  LoadingAssetKey: {
    key: string
    loading: boolean
  }
}

const initialState: ImageState = {
  selectedImageKey: '',
  LoadingAssetKey: {
    key: '',
    loading: false,
  },
}

const imageSlice = createSlice({
  name: 'image',
  initialState,
  reducers: {
    updateSelectedImageKey: (state, action: PayloadAction<string>) => {
      state.selectedImageKey = action.payload
    },
    setLoadingAssetKey: (
      state,
      action: PayloadAction<{ key: string; loading: boolean }>
    ) => {
      state.LoadingAssetKey = action.payload
    },
  },
})

export const { updateSelectedImageKey, setLoadingAssetKey } = imageSlice.actions
export default imageSlice.reducer
